// Carry Roll LandingOverrideInput — collapsible landing-angle override (2.8).
// Activated in Phase 2 (Task P2.5): overrides the computed descent angle to tune roll.

import { ScrubInput } from 'calc-controls';
import { Collapsible } from './Collapsible';
import { useStore } from '../../store';

export function LandingOverrideInput() {
  const override = useStore((s) => s.request.override);
  const setOverride = useStore((s) => s.setOverride);

  return (
    <Collapsible title="Landing-angle override" testId="landing-override" defaultOpen={false}>
      {override.landingAngleDeg == null ? (
        <div className="flex items-center justify-between">
          <span className="text-sm" style={{ color: 'var(--color-text-muted)' }}>
            Auto (calculated from your shot)
          </span>
          <button type="button" className="btn" onClick={() => setOverride({ landingAngleDeg: 45 })}>
            Override
          </button>
        </div>
      ) : (
        <ScrubInput
          label="Landing angle"
          value={override.landingAngleDeg}
          onChange={(v) => setOverride({ landingAngleDeg: v })}
          unit="°"
          min={10}
          max={80}
          step={1}
          decimals={0}
        />
      )}
      {override.landingAngleDeg != null && (
        <div className="mt-2">
          <button type="button" className="btn" onClick={() => setOverride({ landingAngleDeg: null })}>
            Reset to auto
          </button>
        </div>
      )}
      <p className="text-sm" style={{ color: 'var(--color-text-muted)' }}>
        Override the computed descent angle to tune roll. A steeper angle shortens roll; auto uses the
        value calculated from your shot.
      </p>
    </Collapsible>
  );
}
